import { StyleSheet } from 'aphrodite';
import { THEME } from '../Theme/theme';

export const s = StyleSheet.create({
	root: {
		display: 'inline-flex',
		border: `1px solid ${THEME.colors.primary.main}`,
		borderRadius: THEME.common.borderRadius,
		overflow: 'hidden',
		width: 'fit-content',
	},
	item: {
		flex: 1,
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		padding: '10px 16px',
		fontSize: THEME.typography.fontSizes.sm,
		fontWeight: THEME.typography.fontWeights.bold,
		fontFamily: THEME.typography.fontFamilies.lexend,
		color: THEME.colors.primary.main,
		background: THEME.colors.background.light,
		border: 'none',
		borderRight: `1px solid ${THEME.colors.primary.main}`,
		cursor: 'pointer',
		userSelect: 'none',
		transition: 'background 0.15s',
		':last-child': {
			borderRight: 'none',
		},
		':hover:not([data-pressed]):not(:disabled)': {
			background: THEME.colors.hover.light,
		},
		':is([data-pressed])': {
			background: THEME.colors.primary.light,
		},
		':disabled': {
			opacity: 0.5,
			pointerEvents: 'none',
			cursor: 'default',
		},
	},
});
